import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "passwordFields"]

  togglePassword() {
    const hasEmail = this.emailTarget.value.trim().length > 0
    this.passwordFieldsTarget.classList.toggle("hidden", !hasEmail)
  }
}
